import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";
import useFunctions from "../../Hooks/useFunctions";
import logo from "../../Images/fleekCommerceLogo.svg"

const addressDataList = [
  "H-417, R- 7, Baridhara DOHS, Dhaka-1206",
  "+44 454 7800 112",
  "info@zivan.net"
];
const serviceMenuList = [
  {
    title: "WP Development",
    href: "/service/service-details"
  },
  {
    title: "UX Research",
    href: "/service/service-details"
  },
  {
    title: "Branding Design",
    href: "/service/service-details"
  },
  {
    title: "Front-End Development",
    href: "/service/service-details"
  },
  {
    title: "Graphics Design",
    href: "/service/service-details"
  },
  {
    title: "Ad Promotion",
    href: "/service/service-details"
  }
];
const LinksMenuList = [
  {
    title: "Home",
    href: "/"
  },
  {
    title: "About",
    href: "/about"
  },
  {
    title: "Services",
    href: "/service"
  },
  {
    title: "Portfolio",
    href: "portfolio"
  },
  {
    title: "Blog",
    href: "/blog"
  },
  {
    title: "Contact",
    href: "/contact"
  }
];
const policyMenuList = [
  {
    title: "Terms of Use",
    href: "/"
  },
  {
    title: "Privacy Policy",
    href: "/"
  }
];
const socialBtnList = [
  {
    icon: "fa6-brands:linkedin-in",
    href: "/"
  },
  {
    icon: "fa6-brands:twitter",
    href: "/"
  },
  {
    icon: "fa6-brands:youtube",
    href: "/"
  },
  {
    icon: "fa6-brands:facebook-f",
    href: "/"
  }
];

export default function Footer() {
  const { handleScrollToTop, scrollToSection } = useFunctions();
  return (
    <>
      <footer
        className="cs_fooer cs_bg_filed"
        style={{ backgroundImage: "url(/images/footer_bg.jpeg)" }}
      >
        <div className="cs_fooer_main">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-sm-6">
                <div className="cs_footer_item">
                  <Link
                    className="cs_site_branding"
                    to="/"
                    onClick={() => handleScrollToTop()}
                  >
                    <img src={logo} alt="Logo" />
                    {/* <h3 style={{ color: "#ffffff", marginTop: "-1rem" }}>
                      Fleek Commerce
                    </h3> */}
                  </Link>
                  <ul className="cs_menu_widget cs_mp0">
                    {/* {addressDataList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))} */}
                    <p style={{ textAlign: "justify", marginRight: "20px" }}>
                      Elevate your online store with Fleek Commerce. Offering
                      Data Management, Multichannel Tools, Sponsored Ads, and
                      Creative Graphics, we help brands succeed on eCommerce
                      platforms like Amazon, eBay, Walmart, Etsy and more.
                    </p>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">Services</h2>
                  <ul className="cs_menu_widget cs_mp0">
                    {/* {serviceMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))} */}
                    <li>
                      <Link
                        to="/"
                        data-bs-toggle="modal"
                        data-bs-target="#modalDM"
                      >
                        Data Management
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        data-bs-toggle="modal"
                        data-bs-target="#modalMS"
                      >
                        Multichannel Softwares
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        data-bs-toggle="modal"
                        data-bs-target="#modalSA"
                      >
                        Sponsored Ads
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        data-bs-toggle="modal"
                        data-bs-target="#modalDMar"
                      >
                        Digital Marketing
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        data-bs-toggle="modal"
                        data-bs-target="#modalWD"
                      >
                        Website Development
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        data-bs-toggle="modal"
                        data-bs-target="#modalCG"
                      >
                        Creative Graphics
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        data-bs-toggle="modal"
                        data-bs-target="#modalCS"
                      >
                        Customer Support
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">Links</h2>
                  <ul className="cs_menu_widget cs_mp0">
                    {/* {LinksMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))} */}

                    <li>
                      <Link to="/" onClick={() => handleScrollToTop()}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={() => scrollToSection("about-us")}>
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={() => scrollToSection("services")}>
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={() => scrollToSection("blog")}>
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={() => scrollToSection("contact")}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">USA Office </h2>
                  <div className="cs_newsletter cs_style_1">
                    <div className="cs_newsletter_text">
                      <p>
                        {" "}
                        <i
                          className="fa-solid fa-location-dot me-2"
                          style={{ color: "#ffffff" }}
                        ></i>{" "}
                        4885 Route 9 Staatsburg, New York 12581-0369, Hyde Park
                        USA
                      </p>
                      <p>
                        {" "}
                        <i
                          className="fa-solid fa-envelope me-2"
                          style={{ color: "#ffffff" }}
                        ></i>{" "}
                        info@fleekcommerce.com
                      </p>
                    </div>
                  </div>
                </div>

                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">Bangladesh Office </h2>
                  <div className="cs_newsletter cs_style_1">
                    <div className="cs_newsletter_text">
                      <p>
                        {" "}
                        <i
                          className="fa-solid fa-location-dot me-2"
                          style={{ color: "#ffffff" }}
                        ></i>{" "}
                        H-417, R- 7, Baridhara DOHS, Dhaka-1206
                      </p>
                      <p>
                        {" "}
                        <i
                          className="fa-solid fa-envelope me-2"
                          style={{ color: "#ffffff" }}
                        ></i>{" "}
                        info@fleekcommerce.com
                      </p>
                      <p>
                        {" "}
                        <i
                          className="fa-solid fa-phone me-2"
                          style={{ color: "#ffffff" }}
                        ></i>{" "}
                        +8801977016090
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="cs_bottom_footer">
            <div className="cs_bottom_footer_left">
              <div className="cs_social_btns cs_style_1">
                {/* {socialBtnList.map((item, index) => (
                <Link to={item.href} className="cs_center" key={index}>
                  <Icon icon={item.icon} />
                </Link>
              ))} */}

                <Link
                  to="https://www.linkedin.com/company/fleekbangladesh"
                  target="_blank"
                  className="cs_center"
                >
                  <i className="fa-brands fa-linkedin-in"></i>
                </Link>

                <Link
                  to="https://www.facebook.com/fleekbd"
                  target="_blank"
                  className="cs_center"
                >
                  <i className="fa-brands fa-facebook-f"></i>
                </Link>

                <Link
                  to="https://www.youtube.com/@fleekbangladeshdigital"
                  target="_blank"
                  className="cs_center"
                >
                  <i className="fa-brands fa-youtube"></i>
                </Link>

                <Link
                  to="tel:+8801897-621270"
                  target="_blank"
                  className="cs_center"
                >
                  <i
                    className="fa-brands fa-whatsapp"
                    style={{ fontSize: "20px" }}
                  ></i>
                </Link>
              </div>
            </div>
            <div className="cs_copyright">
              Copy © 2024, All Rights Reserved by Fleek Commerce.
            </div>
            <div className="cs_bottom_footer_right">
              <ul className="cs_footer_links cs_mp0">
                <li>
                  <Link to="/" data-bs-toggle="modal" data-bs-target="#modalPP">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Services Modal Privacy Policy Start */}

      <div
        className="modal modal-xl"
        id="modalPP"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <i className="fa-solid fa-envelope"></i> info@fleekcommerce.com
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h3>Privacy Policy</h3>

                <p>
                  At Fleek Commerce, we encourage our customers and prospective
                  clients to review our terms and conditions thoroughly before
                  placing an order for our products or services. By placing an
                  order, you are making an offer to purchase services under the
                  terms outlined in this agreement.
                </p>

                <p>
                  By visiting Fleek Commerce websites or placing an order for
                  our products or services, you agree to be bound by the Terms
                  and Conditions outlined herein. Fleek Commerce reserves the
                  right to modify these terms at any time.
                </p>

                <p>
                  You are advised to periodically review our Terms and
                  Conditions to stay informed of any updates or changes.
                </p>

                <h3>Charges & Payment All Payments Must Be In Us Dollars.</h3>

                <h5 style={{ fontWeight: "500" }}>Termination Of Service:</h5>

                <p>
                  Either party may terminate the Contract by giving at least 30
                  days' written notice, effective on the last day of the minimum
                  contract term or at any time thereafter. If Fleek Commerce
                  issues the notice, the Client will remain responsible for all
                  charges up to the expiration of the notice period. If the
                  Client provides the notice, they will be responsible for all
                  charges until Fleek Commerce receives the notice or for 30
                  days after, whichever is later. The Client's notice does not
                  absolve them from any outstanding obligations for services
                  already provided. Fleek Commerce reserves the right to
                  terminate the contract during the minimum term by giving the
                  Client at least 30 days' prior written notice.
                </p>

                <h5 style={{ fontWeight: "500" }}>
                  Intellectual Property Rights:
                </h5>

                <p>
                  The Client is fully responsible for obtaining any and all
                  necessary consents and clearances to lawfully use any
                  intellectual property rights related to the Services. This
                  includes, but is not limited to, obtaining clearance and
                  consent for the Client's proposed domain name(s) and for any
                  content provided to Fleek Commerce for Website Design
                  services.
                </p>

                <h5 style={{ fontWeight: "500" }}>Assignments:</h5>

                <p>
                  The Client may assign all or part of this Contract to another
                  party only with prior written consent from Fleek Commerce,
                  which may be provided via Skype, email, or letter. Fleek
                  Commerce reserves the right to assign all or part of this
                  Contract at any time to any subsidiary or affiliated company
                  of Fleek Commerce.
                </p>

                <h5 style={{ fontWeight: "500" }}>Law:</h5>

                <p>
                  This Contract is governed by and construed in accordance with
                  the laws of Bangladesh, and the Client hereby submits to the
                  non-exclusive jurisdiction of the courts of Bangladesh.
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
